<template>
  <div class="b-vehicle">
    <div class="b-vehicle__tagged">
      <span v-if="item.highlightText" class="e-guaranteed">
        {{ item.highlightText }}
      </span>
    </div>

    <div class="b-vehicle__body">
      <div class="b-vehicle__header mb-40">
        <div class="b-vehicle__title h4 extrabold">
          {{ item.make }} {{ item.model }}
        </div>
        <div class="b-vehicle__groups mb-10 semibold">
          <ul>
            <li data-bs-toggle="tooltip" :title="dictionary.groupTooltipText">
              {{ item.modelDescription }}
            </li>
          </ul>
        </div>
        <div class="b-vehicle__details">
          <ul>
            <li>
              <div class="pair bold">
                <i class="icon-transmission"></i>
                <span>
                  {{ item.transmissionType }}
                </span>
              </div>
            </li>
            <li>
              <div class="pair bold">
                <i class="icon-fuel"></i>
                {{ item.fuel }}
              </div>
            </li>
            <li v-if="item.emissions">
              <div class="pair bold">
                <i class="icon-emmission"></i>
                {{ item.emissions }} gr/km
              </div>
            </li>
            <li v-if="item.consumption">
              <div class="pair bold">
                <i class="icon-consumption"></i>
                {{ item.consumption }} lt/100km
              </div>
            </li>

            <li v-if="item.energyConsumption">
              <div class="pair bold">
                <i class="icon-consumption"></i>
                {{ item.energyConsumption }} KWh/100Km
              </div>
            </li>
          </ul>
        </div>
      </div>

      <SlickCarousel
        ref="slick"
        :key="'key-' + slickKey"
        class="b-vehicle__slick mb-30"
        :options="slickOptions">
        <div v-for="(image, index) in images" :key="index">
          <LazyImage v-if="image" :image="image" class="item" />
        </div>
      </SlickCarousel>

      <div class="b-vehicle__footer">
        <div class="s-fleet-leasing__space-box grid-view">
          <div class="s-fleet-leasing__box">
            <h2 class="s-fleet-leasing__box__title">
              {{ dictionary.saverLabel }}
            </h2>
            <span>
              {{ dictionary.vehiclePricePrefix }}
              <span class="s-fleet-leasing__box__prices">
                {{ saverPrice }}
              </span>
              {{ dictionary.vehiclePriceSuffix }}
            </span>
          </div>
          <div class="s-fleet-leasing__box theme-black">
            <h2 class="s-fleet-leasing__box__title">
              {{ dictionary.saverPlusLabel }}
            </h2>
            <span>
              {{ dictionary.vehiclePricePrefix }}
              <span class="s-fleet-leasing__box__prices">
                {{ saverPlusPrice }}
              </span>
              {{ dictionary.vehiclePriceSuffix }}
            </span>
          </div>
        </div>
        <div class="b-vehicle__totals mb-20">
          <Anchor
            v-if="item.link"
            :item="item.link"
            class="btn btn-primary btn-full-width" />
        </div>
      </div>

      <div
        v-if="showCompare"
        class="d-none d-lg-flex justify-content-center mt-20">
        <div class="form-check">
          <input
            :id="'checkboxCompare' + item.id"
            v-model="isChecked"
            autocomplete="off"
            class="form-check-input"
            type="checkbox"
            :disabled="disabledCompare" />
          <label class="form-check-label" :for="'checkboxCompare' + item.id">
            {{ dictionary.compareLabel }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import Anchor from './common/Anchor.vue'
import LazyImage from './common/LazyImage.vue'
import SlickCarousel from '../components/common/SlickCarousel.vue'
import mixinsLeasingOffers from './../mixins/leasingOffers-mixins'

export default {
  components: { Anchor, LazyImage, SlickCarousel },
  mixins: [mixinsLeasingOffers],
  props: {
    item: {
      required: true,
      type: Object,
    },
    showCompare: {
      required: false,
      type: Boolean,
    },
    isAlreadyChecked: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      vatIncluded: false,
      slickKey: uuidv4(),
      slickOptions: {
        infinite: true,
        autoplay: false,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false,
      },
    }
  },
  computed: {
    isChecked: {
      get: function () {
        if (!this.recordsCompare.length) {
          return false
        }

        return this.recordsCompare
          .map((x) => x.id)
          .some((x) => x === this.item.id)
      },
      set: function (value) {
        value
          ? this.addRecordToCompare({ value: this.item })
          : this.removeRecordFromCompare({ value: this.item.id })
      },
    },
    disabledCompare() {
      if (this.recordsCompare.map((i) => i.id).includes(this.item.id)) {
        return false
      }

      return this.recordsCompare.length >= this.configuration.compareMaxItems
    },
    guaranteedColor() {
      return this.item.highlightBgColor
    },
    isDisabled() {
      return !this.item.pricePerMonthIncldVat
    },
    images() {
      const images = this.item.galleryImages

      if (!images.length) {
        return []
      }

      return images.map((x) => ({ url: x.url, alt: x.alt }))
    },
    saverPrice() {
      if (!this.item.saverPrices) {
        return ''
      }
      return this.item.saverPrices[0].price
    },
    saverPlusPrice() {
      if (!this.item.flexPrices) {
        return ''
      }
      return this.item.flexPrices[0].price
    },
  },
  mounted() {
    if (this.showCompare) {
      this.isChecked = this.isAlreadyChecked
    }
  },
}
</script>
<style lang="scss" scoped>
.e-guaranteed {
  background-color: v-bind(guaranteedColor);
  color: white;
}
</style>
